<div class="header-cell" *ngIf="!headerParams.isHeaderHidden" [ngClass]="headerParams.classList" [ngStyle]="headerParams.styleList">
	<div class="d-flex header-container">
		<div class="label">{{ headerParams.displayName }}</div>
		<div class="d-flex info">
			<icon [type]="sortIcon" *ngIf="sortIcon" class="sort-icon"></icon>
			<icon
				*ngIf="headerParams.infoBubble && !headerParams.isInfoBubbleModal"
				type="info-circle"
				class="info-circle text-14 color-primary"
				[tooltip]="infoBubble"
				[analytic-data]="{ linkName: 'tooltip_' + headerParams.displayName }"
			></icon>
			<!-- Info bubble for iShares Ideas column -->
			<icon
				*ngIf="headerParams.infoBubble && headerParams.isInfoBubbleModal"
				type="info-circle"
				class="info-circle text-14 color-primary pointer"
				(click)="toggleInfoDialog()"
			>
			</icon>
			<ng-template #infoBubble> <section [innerHTML]="headerParams.infoBubble"></section> </ng-template>
		</div>
	</div>
</div>
